import { PageTypeInterface } from '../interfaces/PageType.interface';

export const PAGE_TYPE: PageTypeInterface = {
  SINGLE: 'single',
  MULTIPLE: 'multiple',
};
